import React from 'react'
import {
  ScrollView,
  Text,
  View,
  StyleSheet,
} from 'react-native'
import { textStyles } from './style'
import { ThemedButton } from './utility/input/buttons'

type ContentProps = {
  onClose: () => void;
}

const ScoreExplanationContent: React.FC<ContentProps> = ({onClose}: ContentProps) => {
  return (
    <>
      <View style={{flex: 1}}>
        <ScrollView style={{flex: 1}} contentContainerStyle={{gap: 10, paddingHorizontal: 16}}>
          <Text style={textStyles.body}>
            Throughout ecountabl you&apos;ll see a score ranging from “1” to
            “100”. That&apos;s the ValueFit Score, a way to tell whether
            you&apos;re living up to your values as a consumer.
          </Text>
          <Text style={textStyles.body}>
            The ValueFit Score measures the social and environmental
            behavior of companies relative to your personal values. A high
            score means a company&apos;s behavior aligns with your values. A
            low score means it conflicts with your values.
          </Text>
          <Text style={textStyles.body}>
            Your personal ValueFit score measures your own alignment with
            your values, considering all of your activities in ecountabl.
          </Text>
        </ScrollView>
      </View>
      <View style={styles.submitButtonWrapper}>
        <ThemedButton
          text="Close"
          onPress={onClose}
          variant="primary"
        />
      </View>
    </>
    
  )
}

export default ScoreExplanationContent

const styles = StyleSheet.create({
  submitButtonWrapper: {
    paddingHorizontal: 16,
    paddingTop: 16
  }
})